const hasStringDecimal = (value: string): boolean =>
  value.search(/,|\./g) !== -1;

const createZerosString = (numberOfZeros: number): string =>
  [...Array(numberOfZeros)].reduce((prev) => `${prev}0`, "");

const getFormattedDecimal = (
  decimal: string,
  maxDecimalCount: number
): string => {
  if (decimal.length > maxDecimalCount)
    return decimal.slice(0, maxDecimalCount);

  const amountOfZerosToAdd = maxDecimalCount - decimal.length;

  return `${decimal}${createZerosString(amountOfZerosToAdd)}`;
};

const formatDecimalString = (
  valueToFormat: string,
  separator: string,
  maxDecimalCount: number
): string => {
  const [numb, decimal] = valueToFormat.split(/,|\./g);

  const formattedDecimal = getFormattedDecimal(decimal, maxDecimalCount);

  return `${numb}${separator}${formattedDecimal}`;
};

const getStringWithoutDecimal = (valueToFormat: string): string => {
  const [numb] = valueToFormat.split(/,|\./g);

  return numb;
};

const getEnrichedValueWithDelimiterAndZeros = (
  valueToFormat: string,
  separator: string,
  maxDecimalCount: number
): string => {
  if (maxDecimalCount === 0) {
    return getStringWithoutDecimal(valueToFormat);
  }
  if (hasStringDecimal(valueToFormat)) {
    return formatDecimalString(valueToFormat, separator, maxDecimalCount);
  }

  return `${valueToFormat}${separator}${createZerosString(maxDecimalCount)}`;
};

export default getEnrichedValueWithDelimiterAndZeros;
